import { createReducer } from "../reducerUtil"
import {
  UPDATE_TAROT_TYPE,
  // UPDATE_TAROT_TEXT,
  // UPDATE_ALL_TAROT_SETTINGS,
  UPDATE_TAROT_DECK,
  UPDATE_DRAW_MODE,
  UPDATE_CARDS_READ,
  UPDATE_IS_ANIMATION_RUNNING,
  OPEN_FINAL_SELECTION_MODAL,
  OPEN_RESTART_CONFIRMATION_MODAL,
} from "./constants"

const initialState = {
  type: "Yes or No or Maybe",
  // text: "",
  deck: "classic",
  drawMode: "triple",
  cardsRead: false,
  isAnimationRunning: false,
  openFinalSelectionModal: false,
  restartConfirmationModal: {
    open: false,
    proceed: false,
  },
}

export const updateTarotType = (state, payload) => {
  return {
    ...state,
    type: payload.type,
  }
}

// export const updateTarotText = (state, payload) => {
//   return {
//     ...state,
//     text: payload.text,
//   }
// }

// export const updateAllTarotSettings = (state, payload) => {
//   switch (payload.page) {
//     case "tarot":
//       return {
//         ...state,
//         text: payload.settings.data.text,
//         question: payload.settings.data.question,
//       }
//   }
// }

export const updateTarotDeck = (state, payload) => {
  return {
    ...state,
    deck: payload.deck,
  }
}

export const updateDrawMode = (state, payload) => {
  return {
    ...state,
    drawMode: payload.drawMode,
  }
}

export const updateCardsRead = (state, payload) => {
  return {
    ...state,
    cardsRead: payload.cardsRead,
  }
}

export const updateIsAnimationRunning = (state, payload) => {
  return {
    ...state,
    isAnimationRunning: payload.isAnimationRunning,
  }
}

export const openFinalSelectionModal = (state, payload) => {
  return {
    ...state,
    openFinalSelectionModal: payload.open,
  }
}

export const openRestartConfirmationModal = (state, payload) => {
  if (payload.proceed) {
    if (payload.settings == "mode") {
      state.drawMode = payload.optionId
    } else {
      state.deck = payload.optionId
    }
  }

  return {
    ...state,
    restartConfirmationModal: payload,
  }
}

export default createReducer(initialState, {
  [UPDATE_TAROT_TYPE]: updateTarotType,
  // [UPDATE_TAROT_TEXT]: updateTarotText,
  // [UPDATE_ALL_TAROT_SETTINGS]: updateAllTarotSettings,
  [UPDATE_TAROT_DECK]: updateTarotDeck,
  [UPDATE_DRAW_MODE]: updateDrawMode,
  [UPDATE_CARDS_READ]: updateCardsRead,
  [UPDATE_IS_ANIMATION_RUNNING]: updateIsAnimationRunning,
  [OPEN_FINAL_SELECTION_MODAL]: openFinalSelectionModal,
  [OPEN_RESTART_CONFIRMATION_MODAL]: openRestartConfirmationModal,
})
